import script from "./JerseyNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./JerseyNumber.vue?vue&type=script&setup=true&lang=js"

import "./JerseyNumber.vue?vue&type=style&index=0&id=b157913c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b157913c"]])

export default __exports__